import { VideoMeetingIntroDialog } from "./VideoMeetingIntroDialog";
import type { MeetingDetails } from "@core/features/videoMeeting";
import { useLocalVideo, useMeetingManager } from "amazon-chime-sdk-component-library-react";

type Props = {
  meetingDetails: MeetingDetails;
};

export function VideoMeetingIntroDialogContainer({ meetingDetails }: Props) {
  const { isVideoEnabled } = useLocalVideo();
  const meetingManager = useMeetingManager();

  const handleClose = async () => {
    try {
      if (!isVideoEnabled) {
        await meetingManager.audioVideo?.stopVideoInput();
      }
    } catch {
      // ignore
    }
  };

  return (
    <VideoMeetingIntroDialog meetingDetails={meetingDetails} onClose={handleClose} />
  );
}

export default VideoMeetingIntroDialogContainer;
